import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/comment-icon.svg")